<template>
  <g>
    <path
      d="M17.09 11.0002H21.95C21.79 9.39024 21.24 7.89024 20.41 6.60024C18.68 7.43024 17.42 9.05024 17.09 11.0002Z"
    />
    <path
      d="M6.90999 11.0002C6.57999 9.05024 5.31999 7.43024 3.58999 6.60024C2.75999 7.89024 2.20999 9.39024 2.04999 11.0002H6.90999Z"
    />
    <path
      d="M15.07 11.0002C15.39 8.41024 16.95 6.21024 19.13 5.00024C17.53 3.37024 15.39 2.29024 13 2.05024V11.0002H15.07Z"
    />
    <path
      d="M8.93 11.0002H11V2.05024C8.61 2.29024 6.46 3.37024 4.87 5.00024C7.05 6.21024 8.61 8.41024 8.93 11.0002Z"
    />
    <path
      d="M15.07 13.0002H13V21.9502C15.39 21.7102 17.54 20.6302 19.13 19.0002C16.95 17.7902 15.39 15.5902 15.07 13.0002Z"
    />
    <path
      d="M3.58999 17.4002C5.30999 16.5702 6.57999 14.9402 6.90999 13.0002H2.04999C2.20999 14.6102 2.75999 16.1102 3.58999 17.4002Z"
    />
    <path
      d="M17.09 13.0002C17.42 14.9502 18.68 16.5702 20.41 17.4002C21.24 16.1102 21.79 14.6102 21.95 13.0002H17.09Z"
    />
    <path
      d="M8.93 13.0002C8.61 15.5902 7.05 17.7902 4.87 19.0002C6.47 20.6302 8.61 21.7102 11 21.9502V13.0002H8.93Z"
    />
  </g>
</template>
